var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-avatar',{staticClass:"md-large"},[(_vm.path)?_c('img',{attrs:{"src":_vm.getFile(_vm.path),"alt":_vm.alt}}):_c('img',{attrs:{"src":require("@/assets/logo-arene.png"),"alt":_vm.alt}})])}
var staticRenderFns = []

export { render, staticRenderFns }